const typographyModalEquipServiceGroup = {
  true: 'Crear',
  false: 'Editar',
  text: 'Sección'
};

export default typographyModalEquipServiceGroup;
